<template>
    <tr :class="{waiter: trip.waiter && trip.active,pulse: trip.waiter && !parseInt(trip.drivers.length),completed: (trip.delivered !== null && trip.transit_action_stage < 5),canceled: trip.canceled}">
        <td class="cell tripnum" :class="{'progress-bar': progress >= 0}">
            <span>
                <page-link page="EditTripPage" :pageData="{id: trip.id}" class="daily_id">
                    #{{trip.daily_id}}
                </page-link>
                &nbsp;
                <span v-if="!trip.canceled" class="tooltip-right" data-tooltip="Cancel Trip">
                    <i class="fa fa-trash" @click="cancel">
                    </i>
                </span>
                <span v-if="trip.canceled" class="tooltip-right" data-tooltip="Uncancel Trip">
                    <i class="fa fa-undo" @click="uncancel">
                    </i>
                </span>
            </span>
        </td>
        <td class="cell stock" :class="{'progress-bar': progress >= 0}"> <!--, 'urgent': (trip.waiter || appt_time_soon)}">-->
            <div>
                <vehicle-select @change="updateVehicle" :currentValue="trip.stock_num" class="tooltip-bottom" :data-tooltip="managerToolTip"/>
            </div>
            <span v-if="trip.skip_wash" class="urgent">
                Skip Wash!
            </span>
            <appt-time :currentValue="trip.appt_time" @change="updateApptTime" :class="{'urgent': appt_time_soon}"/>
            <guest-name :currentValue="trip.guest_name" @change="updateGuestName"/>
            <trip-ticket :trip="trip"/>
            <small> <!--CREATED_AT TIMESTAMP this small code snippet displays dynamic created at time on logistics trips page-->
                {{ trip.created_at ? 'Created' : 'No associated timestamp' }} 
                <timestamp :time="trip.created_at"/>
            </small>
        </td>
        <td class="cell driver" :class="{'progress-bar': progress >= 1}" @focusout="closeDriverAssignment">
            <driver-select v-show="trip.assigned_time || assigningDriver" :trip="trip" @blur="closeDriverAssignment" ref="driver"/>
            <small v-if="trip.assigned_time">
                Assigned
                <timestamp :time="trip.assigned_time"/>
            </small>
            <small v-else @click="openDriverAssignment" data-tooltip="Click to select a driver">
                Not Assigned Yet
            </small>
        </td>
        <td class="cell from" :class="{'progress-bar': progress > 2}">
            <location-select @change="updateFrom" :currentValue="trip.from"/>
            <v-button v-if="showLeaving" :disabled="!enableLeaving" class="hidden-button leaving-button" @click="beginTrip">
                <i class="fa fa-play"></i>
            </v-button>
            <small v-if="!showLeaving" class="leaving-button">
                <undo v-if="showCompleted" @click="unBeginTrip" class="tooltip-bottom" data-tooltip="Cancel Leaving"/>
            </small>
        </td>
        <td class="cell transitStatus" :class="{'progress-bar': progress >= 3, 'partial-progress-bar-three-tenths': progress == 2.3, 'partial-progress-bar-six-tenths': progress == 2.7, 'partial-progress-bar-nine-tenths': progress == 2.9}">
            <div class="transitCurrentActionsDiv">
                <div class="transitStatusDiv">
                    <div class="mainActionStatusDisplayText">
                        {{ this.currentMainActionDisplayText }}
                    </div>
                    <small v-if="trip.transit_action_stage > 0">
                        <timestamp :time="currentMainActionTime"/>
                    </small>
                </div>
                <div class="transitStatusDiv" v-if="subActionActive">
                    <div class="subActionStatusDisplayText">
                        {{ this.currentSubActionDisplayText }}
                    </div>
                    <small>
                        <timestamp :time="trip.transit_delay_time"/>
                    </small>
                </div>
            </div>
        </td>
        <td class="cell to" :class="{'progress-bar': progress >= 3}">
            <location-select @change="updateTo" :currentValue="trip.to"/>
            <v-button v-if="showCompleted" :disabled="!enableCompleted" class="success completed-button hidden-button" data-tooltip="Complete Trip" @click="complete">
                <i class="fa fa-flag-checkered"></i>
            </v-button>
            <small v-if="!showCompleted" class="completed-button">
                <timestamp :time="trip.delivered" prefix="Completed "/>
                &nbsp;
                <undo v-if="trip.delivered" @click="uncomplete" class="tooltip-bottom" data-tooltip="Cancel Completed"/>
            </small>
        </td>
        <td class="cell details" :class="{'progress-bar': progress >= 4}">
            <div v-if="!trip.waiter">
                <v-input @change="updateWaiter" class="check-text" type="checkbox" display="pending" label="Waiter" :currentValue="trip.waiter">
                  {{trip.waiter ? 'Guest Waiting!' : 'Guest waiting?'}}
                </v-input>
            </div>
            <div v-if="trip.waiter && isProductSpecialistPickup">
                Coming to Pick Up !!!
            </div>
            <div v-if="trip.waiter && !isProductSpecialistPickup">
                <small>
                    Deliver to:
                </small>
                <undo @click="updateWaiter(false)" data-tooltip="Cancel waiter"/>
                <user-select @change="updateProductSpecialist" :currentValue="fetchProductSpecialist(trip.product_specialist)" :options="productSpecialists"/>
            </div>
        </td>
        <td class="cell notes" :class="{'progress-bar': progress >= 4}">
            <template v-if="trip.canceled">
                <small>
                    Canceled By:
                </small>
                <user :id="trip.canceled_by"/>
                <small>
                    <timestamp :time="trip.canceled_at"/>
                </small>
            </template>
            <trip-note-list :trip="trip"/>
        </td>
    </tr>
</template>

<script>
    import epoch from 'epoch.js'
    import moment from 'moment'
    import PageLink from './PageLink.vue'
    import VehicleSelect from './VehicleSelect.vue'
    import ApptTime from './ApptTime.vue'
    import GuestName from './GuestName.vue'
    import TripTicket from './TripTicket.vue'
    import Timestamp from './Timestamp.vue'
    import DriverSelect from './DriverSelect.vue'
    import LocationSelect from './LocationSelect.vue'
    import Undo from './Undo.vue'
    import UserSelect from './UserSelect.vue'
    import User from './User.vue'
    import TripNoteList from './TripNoteList.vue'

    export default {
        data() {
            return {
                assigningDriver: false,
                pollApppointment: null,
                appt_time_soon: false
            }
        },
        props: [
            'trip'
        ],
        components: {
            'page-link': PageLink,
            'vehicle-select': VehicleSelect,
            'appt-time': ApptTime,
            'guest-name': GuestName,
            'trip-ticket': TripTicket,
            'timestamp': Timestamp,
            'driver-select': DriverSelect,
            'location-select': LocationSelect,
            'undo': Undo,
            'user-select': UserSelect,
            'user': User,
            'trip-note-list': TripNoteList
        },
        created() {
            this.pollApppointment = setInterval(() => {
                                                        this.checkAppointmentTime();
                                                    }, 5000);
        },
        updated() {
            if(this.assigningDriver) {
                this.$refs.driver.$refs.el.$refs.el.focus();
            }
        },
        beforeDestroy () {
            clearInterval(this.pollApppointment);
        },
        methods: {
            updateApptTime (appt_time) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {appt_time: appt_time});
            },
            updateGuestName (guest_name) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {guest_name: guest_name});
            },
            updateFrom (from) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {from: from});
            },
            updateTo (to) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {to: to});
            },
            updateVehicle (stock_num) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {stock_num: stock_num});
            },
            updateProductSpecialist (product_specialist) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {product_specialist: product_specialist});
            },
            updateRequestingManager (mgr_requested) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {mgr_requested: mgr_requested});
            },
            updateWaiter (value) {
                this.$eventHub.$emit('updateTrip', this.trip.id, {waiter: value});
            },
            beginTrip () {
                this.$eventHub.$emit('updateTrip', this.trip.id, {transit_action_time: epoch().datetime(), transit_action_stage: 2});
            },
            unBeginTrip () {
                this.$eventHub.$emit('updateTrip', this.trip.id, {transit_action_time: null, transit_action_stage: 1});
            },
            complete () {
                this.$eventHub.$emit('updateTrip', this.trip.id, {delivered: epoch().datetime(), transit_action_stage: 5});
            },
            uncomplete () {
                this.$eventHub.$emit('updateTrip', this.trip.id, {delivered: null, transit_action_stage: 2});
            },
            cancel () {
                if(confirm('This will cancel the trip. Are you sure?')) {
                    this.$eventHub.$emit('updateTrip', this.trip.id, {canceled: true, canceled_at: epoch().datetime(), canceled_by: this.user.id});
                }
            },
            uncancel () {
                this.$eventHub.$emit('updateTrip', this.trip.id, {canceled: false, canceled_at: epoch().datetime(), canceled_by: this.user.id});
            },
            renderLocation (id) {
                return this.$privateReactiveStore.getLocation(id);
            },
            fetchManager (id) {
                return this.$privateReactiveStore.getManager(id);
            },
            fetchProductSpecialist (id) {
                return this.$privateReactiveStore.getProductSpecialist(id);
            },
            fetchDispatcher (id) {
                return this.$privateReactiveStore.getDispatcher(id);
            },
            openDriverAssignment() {
                this.assigningDriver = true;
            },
            closeDriverAssignment() {
                this.assigningDriver = false;
            },
            checkAppointmentTime() {
                console.log("CHECK APPOINTMENT TIME");
                let appt_time = this.trip.appt_time ? new Date(this.trip.appt_time) : null;
                let soon = false;

                if(appt_time && appt_time.getTime()) {
                    soon = (appt_time - Date.now()) < (1000 * 60 * 60 * 2);
                }

                this.appt_time_soon = soon;
            }
         },
        computed: {
            progress () {
                if (!this.trip.drivers) {
                    return 0;
                }
                
                if (this.trip.transit_action_stage >= 2 && this.trip.transit_action_stage < 3) {
                    let progress = 2

                    if(this.trip.transit_action_stage == 1) {
                        progress = 2.3;
                    }
                    else if(this.trip.transit_action_stage == 2) {
                        progress = 2.7;
                    }
                    else if(this.trip.transit_action_stage == 3) {
                        progress = 3;
                    }

                    return progress;
                }

                return this.trip.transit_action_stage;
            },
            enableLeaving () {
                return this.trip.assigned_time && this.trip.transit_action_stage > 0;
            },
            showLeaving () {
                return this.trip.transit_action_stage == 1;
            },
            enableCompleted () {
                return this.trip.assigned_time && this.trip.transit_action_stage >= 2 && !this.trip.delivered;
            },
            showCompleted () {
                return !this.trip.delivered && this.trip.transit_action_stage >= 1;
            },
            managerToolTip() {
                let manager = this.fetchManager(this.trip.mgr_requested);

                return  manager ? 'Requested by ' + manager.full_name : '';
            },
            productSpecialists () {
                return this.$privateReactiveStore.getProductSpecialists()
            },
            drivers () {
                let drivers = [{}];
                // Add all drivers one by one
                let separatorAlready = false
                for (let i = 0; i < this.$privateReactiveStore.drivers.length; i++) {
                if (!separatorAlready && this.$privateReactiveStore.drivers[i].role !== 'driver') {
                    // Insert a separator between drivers and backup drivers
                    drivers.push({
                    diabled: "1",
                    full_name: '──────────',
                    id: '',
                    })
                    separatorAlready = true
                }
                drivers.push(this.$privateReactiveStore.drivers[i])
                }
                return drivers
            },
            user () {
                return this.$privateReactiveStore.getUser();
            },
            isProductSpecialistPickup () {
                return this.trip.drivers.includes(this.trip.product_specialist)
            },
            appt_time () {
                return epoch(this.trip.appt_time).format('MM/DD H:mmA')
            },
            displayDriverSelect() {
                return this.trip.assigned_time || this.assigningDriver;
            },
            recentlyResolvedDelay() {
                let recentlyResolvedDelay = null;

                if(this.trip.transit_delay_id == null && this.trip.transit_delay_time && this.trip.transit_delays_resolved) {
                    let delaysResolved = this.trip.transit_delays_resolved.split(',');
                    
                    recentlyResolvedDelay = this.$privateReactiveStore.getDelay(delaysResolved[delaysResolved.length - 1]);
                    recentlyResolvedDelay = recentlyResolvedDelay.stage != this.trip.transit_action_stage ? null : recentlyResolvedDelay;
                }

                return recentlyResolvedDelay;
            },
            subActionActive() {
                let delayActive = false;
                
                if(this.trip.transit_delay_id != null) {
                    delayActive = true;
                }
                else if(this.recentlyResolvedDelay) {
                    delayActive = true;
                }

                return delayActive;
            },
            currentMainActionDisplayText() {
                let mainActionDisplay = this.trip.assigned_time ? "Driver Assigned" : 'Not Yet Assigned';

                if(this.trip.transit_action_stage == 2) {
                    mainActionDisplay = "Left " + this.$privateReactiveStore.getLocation(this.trip.from).name;
                }
                else if(this.trip.transit_action_stage == 3) {
                    mainActionDisplay = "Arrived at " + this.$privateReactiveStore.getLocation(this.trip.to).name;
                }
                else if(this.trip.transit_action_stage >= 4) {
                    let deliveredTo = this.trip.delivered_to;
                    mainActionDisplay = "Delivered";

                    if(deliveredTo) {
                        if(/^\d+$/.test(deliveredTo)) {
                            let prod_spec = this.fetchProductSpecialist(deliveredTo);
                            deliveredTo = prod_spec.full_name;
                        }    
                        
                        mainActionDisplay += " to " + deliveredTo;
                    }
                }

                return mainActionDisplay;
            },
            currentMainActionTime() {
                let currentMainActionTime = this.trip.assigned_time ? this.trip.assigned_time : null;

                if(currentMainActionTime && this.trip.transit_action_stage > 1) {
                    currentMainActionTime = this.trip.transit_action_time;

                    if(this.trip.transit_status_stage == 4) {
                        currentMainActionTime = this.trip.delivered;
                    }
                }

                return currentMainActionTime;
            },
            currentSubActionDisplayText() {
                let delayActiveText = '';

                if(this.trip.transit_delay_id != null) {
                    delayActiveText = this.$privateReactiveStore.getDelay(this.trip.transit_delay_id).delay_text;
                }
                else if(this.recentlyResolvedDelay) {
                    delayActiveText = this.recentlyResolvedDelay.delay_resolved_text;
                }
                
                return delayActiveText;
            }
        },
        watch: {
            appt_time(newApt, oldApt) {
                if(newApt != oldApt) {
                    this.checkAppointmentTime();
                }
            }
        }
    }
</script>

<style scoped lang="less">
    i.fa-trash {
      color: #0074d9;
      &:hover {
        color: #d90074;
      }
    }

    i.fa-minus {
      color: #d90074;
    }

    .hidden-button {
      background: none;
      color: #0074d9;
    }

    button[disabled] {
      color: #AAA;
    }

    tr:nth-child(odd) {
      background: white;
    }

    tr:nth-child(even) {
      background: rgb(242, 242, 242);
    }

    .triptable .canceled,
    .triptable .completed {
      &:nth-child(odd) {
        background: #AAA;
      }
      &:nth-child(even) {
        background: #AAA;
      }
      * {
        filter: grayscale(100%) opacity(75%);
      }
    }

    .canceled {
      font-variant: italic;
      text-decoration: line-through;
    }

    .unimportant {
      background: #BBB;
    }

    .urgent {
        color: #ff4136; 
       font-weight: bold; 
    }

    .cell {
        position: relative;
        &.tripnum {
            text-align: center;
        }
        // Why does picnic.css have such weird default cell padding???
        padding: .25em;
        &.progress-bar {
            border-bottom: 5px solid #2ecc40;
        }

        &.partial-progress-bar-three-tenths:nth-child(even) {
            background:linear-gradient(to right, #2ecc40 30%, rgb(242, 242, 242) 70%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }

        &.partial-progress-bar-six-tenths:nth-child(even) {
            background:linear-gradient(to right, #2ecc40 60%, rgb(242, 242, 242) 40%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }

        &.partial-progress-bar-nine-tenths:nth-child(even) {
            background:linear-gradient(to right, #2ecc40 90%, rgb(242, 242, 242) 10%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }

        &.partial-progress-bar-three-tenths:nth-child(odd) {
            background:linear-gradient(to right, #2ecc40 30%, white 70%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }

        &.partial-progress-bar-six-tenths:nth-child(odd) {
            background:linear-gradient(to right, #2ecc40 60%, white 40%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }

        &.partial-progress-bar-nine-tenths:nth-child(odd) {
            background:linear-gradient(to right, #2ecc40 90%, white 10%) bottom;
            background-repeat: no-repeat;
            background-size:100% 5px;
            border-bottom: none;
        }
    }

    .cell.to {
        white-space: nowrap;
    }

    .cell from {
        white-space: nowrap;
    }

    .cell.stock>span {
       /*color: #ff4136; */
       font-weight: bold
    }

    .tripnum span {
        white-space: pre-line
    }

    .triptable tr.waiter:nth-child(even),
    .triptable tr.waiter:nth-child(odd) {
      background-color: #FFDD1B;
    }

    .triptable tr.pulse:nth-child(even),
    .triptable tr.pulse:nth-child(odd) {
      background-image: linear-gradient(to right, #FFDD1B 0%,#FFDD1B 65%,#D7FFD1 80%,#FFDD1B 95%,#FFDD1B 100%);
      background-size: 100vw 20px;
      animation: shine 2s linear infinite;
    }

    @keyframes shine {
      to {background-position: 100vw 0;}
    }

    .check-text {
      //display: inline-block;
      float: left;
      line-height: 50px;
    }

    button {
      white-space: nowrap;
    }

    @media (max-width: 1270px) {
      tr {
        display: flex;
        flex-wrap: wrap;
        align-items: bottom;
        border: 15px solid black;
        td {
          flex-grow: 1;
        }
      }
      tr:nth-child(even) td {
        border: 3px solid white;
      }
      tr:nth-child(odd) td {
        border: 3px solid #f2f2f2;
      }
    }

    .transitCurrentActionsDiv {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: start;
    }

    .transitStatusDiv {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 50%;
        justify-content: start;
    }

    .mainActionStatusDisplayText {
        margin: .25vh 0;
        font-weight: bold;
        font-size: 1.2em;
    }

    .subActionStatusDisplayText {
        margin: .25vh 0;
        font-weight: bold;
        font-size: 1.05em;
    }
</style>
